module.exports = __webpack_public_path__ + "static/img/ap8.39b5d7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/ap8.jpg
// module id = zLjz
// module chunks = 1